var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwdViewFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91269 17.5L6.3963 17.1595L7.01432 15.2279C6.08922 14.9423 5.22944 14.5262 4.47233 13.9975L2.7816 15.4132L1.67041 14.4832L3.36193 13.0682C2.40707 12.1111 1.7655 10.9629 1.5 9.73595L3.04545 9.5C3.64149 12.2617 6.52822 14.357 10 14.357C13.471 14.357 16.3585 12.2617 16.9545 9.5L18.5 9.73529C18.2349 10.9624 17.5936 12.1108 16.6389 13.0682L18.3296 14.4832L17.2184 15.4132L15.5277 13.9975C14.7706 14.5262 13.9108 14.9423 12.9857 15.2279L13.6037 17.1602L12.0873 17.5L11.4685 15.5677C10.4966 15.7071 9.50342 15.7071 8.5315 15.5677L7.91269 17.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdViewFalse);
export default __webpack_public_path__ + "static/media/pwd-view-false.e7333c6b493e483bd795827b4c39f4b7.svg";
export { ForwardRef as ReactComponent };